import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { CheckboxesChip } from './CheckboxesChip';
import { MinMaxChip } from './MinMaxChip';
import { NumberRangeChip } from './NumberRangeChip';
import { RadioChip } from './RadioChip';
import { TextChip } from './TextChip';
import { ToggleChip } from './ToggleChip';
export { GetAiFilterChipTID } from './AiChipShell';
export const AiFilterChip = (props)=>{
    switch(props.mode){
        case 'checkboxes':
            return /*#__PURE__*/ _jsx(CheckboxesChip, _object_spread({}, props));
        case 'radio':
            return /*#__PURE__*/ _jsx(RadioChip, _object_spread({}, props));
        case 'text':
            return /*#__PURE__*/ _jsx(TextChip, _object_spread({}, props));
        case 'numberRange':
            return /*#__PURE__*/ _jsx(NumberRangeChip, _object_spread({}, props));
        case 'minMax':
            return /*#__PURE__*/ _jsx(MinMaxChip, _object_spread({}, props));
        case 'toggle':
            return /*#__PURE__*/ _jsx(ToggleChip, _object_spread({}, props));
    }
};
